export default __webpack_public_path__ + "static/media/report_05.763a6d43.png";